import { useState, useEffect, useCallback } from 'react';
import { authFetch } from '../utils/api';

export function useForecastGrid() {
  const [data,    setData]    = useState(null);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);

  const fetchData = useCallback(() => {
    setLoading(true);
    setError(null);
    authFetch('/api/forecast/grid')
      .then(r => { if (!r.ok) throw new Error(r.statusText); return r.json(); })
      .then(d  => { setData(d); setLoading(false); })
      .catch(e => { setError(e.message); setLoading(false); });
  }, []);

  useEffect(() => { fetchData(); }, [fetchData]);

  return { data, loading, error, refresh: fetchData };
}